var _path, _g, _path2, _g2, _path3, _path4, _g3, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZigzagPatternRight = function SvgZigzagPatternRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1280 690",
    preserveAspectRatio: "xMidYMin slice",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zigzag-pattern-right_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "zigzag-pattern-right_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1241,
    y: -685,
    width: 529,
    height: 1400
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1241-685h529V714h-529V-685Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#zigzag-pattern-right_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1490-685 1 4 62 93 107 163 41 62 2 4-161 160-162 160 240 51-48 65-47 64-47 65-48 64a192861 192861 0 0 0-47 64l-47 65-47 64-48 65 221 186 67-103-226-103 3-4 36-44 60-72 108-128 77-93 101-121 65-78 3-4-117-13-117-13v-3l3-2 244-285 1-1-2-3-70-109-93-145-46-71-2-4h-67Z",
    fill: "#1A1A24"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "zigzag-pattern-right_svg__c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 418,
    y: 593,
    width: 1394,
    height: 538
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M418 593h1394v538H418V593Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#zigzag-pattern-right_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m547 1131 66-243 47 18 47 17 47 18 47 18 46 17 46 18 47 17 47 18 233-354 22 22 23 23 22 23 22 22 22 23 22 22 23 23 22 23 22 23 22 22 23 23 136-183 5 2 198 84 8 3v-55l-5-2-151-74a63510 63510 0 0 0-49-23l-3-1-133 145-267-227-3 5-108 170-97 151-26 42a182 182 0 0 1-2 3c-2 3-2 3-7 2l-13-6-245-97-99-39-4-2-3 4a3075002 3075002 0 0 0-157 268l-20 32-2 5h129Z",
    fill: "#1A1A24"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m-4 145 93-92 136 137L361 8l135-182 1 1h1l1 2 148 341h1l2-3 39-78c1-3 0-5-1-8l-36-67-55-104-65-123a53726 53726 0 0 0-21-40l-3-4-262 362-4-4-56-70A741167 741167 0 0 0 89-90l-3-3-4 3-48 55L-4 6v139Z",
    fill: "#1A1A24"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "zigzag-pattern-right_svg__d",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: 501,
    width: 552,
    height: 630
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-4 502h552v629H-4V502Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#zigzag-pattern-right_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4 567 24 12 82 41 136 68 134 68a18877 18877 0 0 1 32 17l4 2-3 9-65 221-37 124v2h61l2-4 129-236 50-91 3-5-4-3-197-104-175-93A653816 653816 0 0 0-1 503l-3-1v65Z",
    fill: "#1A1A24"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m-4 709 261 136-58 176-42-21-42-22a1561029 1561029 0 0 0-102 89v1l1 1 227 50h2l75-315-3-2-128-65-158-79-33-16v67Zm0-375 72-74 46 37-4 4L-1 440l-3 4 49 30 138-226-114-78-73 71v94Z",
    fill: "#1A1A24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m126-525-5 18-28 113-34 135v1c-2 5-1 8 2 13l96 142 81 122a2619 2619 0 0 0 11 15l2 3 70-107-3-3a224629 224629 0 0 0-77-77l-52-52-54-52-18-18c-3-3-3-4-1-7l46-91 46-92c2-4 2-4 7-3l106 25 180 42 171 40 12 2c3 1 5 2 7 5l38 61 76 119 29 46c2 3 2 5 1 8L778 9 677 233a45496 45496 0 0 1-24 54l-3 4-57-122-56-123-57-123-3 3-50 76a745224 745224 0 0 1-89 132l-56 84-87 129-85 126-15 23-3 4 4 2 110 55 154 78 101 51 103 52 102 51 103 51 101 52 64 32 4 2 455-716L1178-5c-2 1-79 152-84 163l33 9 32 10 33 9 32 9 33 9a86486 86486 0 0 1-359 656l-5-2-61-36-192-112-203-119-172-101-49-29-5-2 2-5a2594594 2594594 0 0 1 209-347l49-82 4-6 2 4a85944 85944 0 0 1 32 89l63 170 55 152 7 19 2 4 6-13 43-89 68-141 70-148 86-179 12-27c2-2 2-4 0-7l-67-91-136-185a14 14 0 0 0-10-6l-124-21-126-20-119-20-101-16-108-18-4-1Z",
    fill: "#1A1A24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m1135-211 409-300-54-90c-4 2-72 60-115 98l-114 99-114 99c-4-2-48-48-88-91l-87-91-87-92-96 157 3 5 178 245 29 41c3 3 3 6 1 9L875 106l-90 165-136 249-7 13-2 4-272-132c1-4 60-108 63-110l3 5 68 123c1 3 3 4 6 6l80 39h3a2409680 2409680 0 0 0-139-327l-2-4-152 283 364 228 422-791-233-273 58-80h2l1 1 2 2 220 281 1 1Z",
    fill: "#1A1A24"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m1564-395 27 30-30 26-30 26-29 26-30 26-29 25-30 26-30 26-29 25-30 26-30 26-29 26-30 25-30 26 210 205 98-139-113-23-113-23 3-4 64-62 55-53 83-80 55-53 78-75 22-21 5-5-80-113-21 16a989084 989084 0 0 0-175 134l-209 160-33 25-4 5-67 126-76 141-66 124-74 136-89 166-57 107-2 4 169 114 315-539-106-48-55 110h5l63-12h4l-1 2-256 410-4-3a23542 23542 0 0 1-49-34c-3-2-3-2-2-6a14200 14200 0 0 1 22-42l38-74 83-162 56-112 69-134 54-107 55-106 4-5 177-140 178-139 42-34 4-2Zm-976 56 2 4 53 81 81 123c1 2 2 4 1 7l-18 47-3 5-3-5-61-101-114-185c-1-2-3-3-5-3h-26c-3 0-5 1-6 3l-81 118-48 71-3 3-5-5-42-43-82-86c-3-3-3-3-1-7l26-54 2-4c4 2 21 20 39 38l37 39 39 39 22-37 22-37 22-38-206-61-5 12-53 122c-1 4-1 4 1 7l74 78 54 58 42 44 3 3 158-216 106 165L715 10l2-3 56-128v-8L673-314c-2-4-5-6-9-7l-71-17-5-1Z",
    fill: "#1A1A24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zigzag-pattern-right_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1280v690H0z"
  })))));
};
export default SvgZigzagPatternRight;